<template>
  <div class="pointInfo">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">点位信息</h2>
      <!--      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急队伍</h2>-->
      <Divider/>
      <div style="width: 60%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="监控点位名称" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写监控点位名称"></Input>
          </FormItem>
          <FormItem label="监控设备id" prop="deviceId">
            <Input v-model="formValidate.deviceId" placeholder="请填写监控设备id"></Input>
          </FormItem>
          <FormItem label="通道ID" prop="channelId">
            <Input v-model="formValidate.channelId" placeholder="请填写通道ID"></Input>
          </FormItem>
          <FormItem label="所属区域" prop="indexCode">
            <Select transfer clearable v-model="formValidate.indexCode" placeholder="所属区域">
              <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="摄像头类型" prop="cameratype">
            <Input v-model="formValidate.cameratype" placeholder="请填写摄像头类型"></Input>
          </FormItem>
          <FormItem label="经纬度">
            <Row :gutter="4">
              <Col :span="3">
                <Button type="primary" @click="getLocationByMap">定位</Button>
              </Col>
              <!--              <Col :span="3">-->
              <!--                <Button type="primary" @click="getLocation">定位</Button>-->
              <!--              </Col>-->
              <Col :span="8">
                <FormItem prop="longitudeBaidu">
                  <Input v-model="formValidate.longitudeBaidu" placeholder="请填写经度（百度）"></Input>
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem prop="latitudeBaidu">
                  <Input v-model="formValidate.latitudeBaidu" placeholder="请填写纬度（百度）"></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="监控流状态" prop="streamingstatus">
            <Input v-model="formValidate.streamingstatus" placeholder="请填写监控流状态"></Input>
          </FormItem>
          <FormItem label="监控流信息" prop="streamingdesc">
            <Input v-model="formValidate.streamingdesc" placeholder="请填写监控流信息"></Input>
          </FormItem>
        </Form>
        <div style="text-align: center">
          <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
          <!--          <Button v-if="formValidate.id" type="primary" @click="">编辑</Button>-->
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </div>
      </div>
    </Card>

    <Modal
        v-model="modal"
        title="地图"
        @on-ok="ok"
        @on-cancel="cancel">
      <div style="margin-bottom: 10px">
        <AutoComplete
            transfer
            clearable
            v-model="searchPlace"
            @on-search="handleSearch"
            placeholder="请输入搜索地址"
            style="width:200px">
          <Option v-for="item in searchList" :value="item.title" :key="item.uid">{{ item.title }}</Option>
        </AutoComplete>
        <Button type="primary" @click="getLocal">搜索</Button>
      </div>

      <div id="map" style="width: 100%;height: 400px"></div>
    </Modal>
  </div>
</template>

<script>
import {BMapLoader} from '@/utils/mapLoader'

export default {
  name: "pointInfo",
  data() {
    return {
      countryList: [],
      searchPlace:'',
      searchList: [],
      modal: false,
      warningTypeList: [],
      formValidate: {
        name: '',
        deviceId: '',
        channelId: '',
        indexCode: '',
        cameratype: '',
        longitudeBaidu: '',
        latitudeBaidu: '',
        streamingstatus: '',
        streamingdesc: '',
      },
      ruleValidate: {},
    }
  },
  mounted() {
    if (this.$route.params.row) {
      this.formValidate = this.$route.params.row
      console.log(this.formValidate)
    }
    this.getCountry()
  },
  methods: {
    getLocationByMap() {
      this.modal = true
      this.initBMap()
    },
    ok() {
      this.formValidate.latitudeBaidu = this.local[0].point.lat
      this.formValidate.longitudeBaidu = this.local[0].point.lng
    },
    cancel() {
    },
    handleSearch(str){
      const _this = this
      var options = {
        onSearchComplete: function(res){ //检索完成后的回调函数
          var s = [];
          if (local.getStatus() == BMAP_STATUS_SUCCESS){
            for (var i = 0; i < res.getCurrentNumPois(); i ++){
              s.push(res.getPoi(i));
            }
            // console.log(s)
            _this.searchList = s
          } else{
            _this.searchList = s
          }
        }
      }
      var local = new _this.BMap.LocalSearch(_this.map, options) //创建LocalSearch构造函数
      local.search(str) //调用search方法，根据检索词str发起检索
    },
    getLocal(){
      console.log(this.searchPlace)
      this.local = this.searchList.filter(item => item.title === this.searchPlace && item.type === 0)
      console.log(this.local)
      if(this.local.length > 0){
        for (var i=0;i<this.local.length;i++){
          var lat = this.local[i].point.lat // 经度
          var lng = this.local[i].point.lng // 纬度
          var point = new this.BMap.Point(lng, lat)
          var marker = new this.BMap.Marker(point)
          this.map.addOverlay(marker);
          this.map.centerAndZoom(point, 16)
        }
      }
    },
    initBMap() {
      BMapLoader('DeMrIzatabf5IUkmHah870RHzfbwm9YW').then(BMap => {
        const map = new BMap.Map('map', {enableMapClick: false})
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.Map.addOverlay(marker);
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getAllCountys').then(res => {
        // console.log(res)
        this.countryList = res.data
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  }
}
</script>

<style scoped>

</style>
